import gql from "graphql-tag";

const SITE_TYPE_PROPS = gql`
  fragment siteType on SiteType {
    id
    name
    created_at
  }
`;

export const GET_SITE_TYPE = gql`
  query GetSiteTypes($siteId: String!) {
    GetAllSiteType(id: $siteId) {
      docs {
        ...siteType
      }
    }
  }
  ${SITE_TYPE_PROPS}
`;

export const NEW_SITE_TYPE = gql`
  mutation CreateSiteType($name: String!) {
    CreateSiteType(name: $name) {
      message
      doc {
        ...siteType
      }
    }
  }
  ${SITE_TYPE_PROPS}
`;

export const UPDATE_SITE_TYPE = gql`
  mutation UpdateSiteType($id: ID!, $name: String!) {
    UpdateSiteType(id: $id, name: $name) {
      message
      doc {
        ...siteType
      }
    }
  }
  ${SITE_TYPE_PROPS}
`;
